import 'idempotent-babel-polyfill';
import './shims/prepend';
import './shims/classList';
import './shims/closest';
import { bootstrap } from 'conversional-iframe-dom';
import RPCManager from './rpc/rpcManager';
bootstrap().then(function () {
    window.conversionalClient = new RPCManager({ isReady: true }).client;
});
